import React from 'react';
import { modelClass } from '/imports/api/tradeItems';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const TradeItemPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'qty', label: 'Quantity' }], [{ field: 'action', label: 'Action' }], [{ field: 'price', label: 'Price' }]]}
  />
);
